export default __webpack_public_path__ + "static/neuchatel-bg-8a6ea6128136be5646ac0e559ade3192.webp";